import React, { useEffect, useState } from 'react';
import { 
    getFirestore, 
    collection, 
    query,
    getDocs,
} from "firebase/firestore"; 
import {
  Link,
  useLocation,
} from "react-router-dom";
import HeaderComponent from '../../components/header';
import FooterComponent from '../../components/footer';
// import ItemBoxRegular from '../../components/item-box-regular';

const db = getFirestore();

function HomeView() {
    const [allQuestions, setAllQuestions] = useState(false);
    const [submitModal, setSubmitModal] = useState(false);
    const [featured, setFeatured] = useState(false);

    const location = useLocation();

    useEffect(() => {
        queryData();

        // show submitted modal
        if ( location !== null ) {
            if ( location?.state?.userState == 'submitted' ) {
                setSubmitModal(true);
            }
        }
    }, []);

    let getImage = (item) => {
        let imageDefault = require('../../assets/bg-text.png');
        if ( typeof item.image !== 'undefined' && item.image !== false ) {
            imageDefault = item.image;
        }
        return imageDefault;
    }

    async function queryData() {
        let q = query(collection(db, 'questions'));
        const qr = await getDocs(q);
        let qArr = [];
        let featured = 0;
        qr.forEach((e, i) => {
            let temp = e.data();
            temp.id = e.id;

            if (temp.defaultQ) {
                featured = i;
                setFeatured(temp);
            }
            qArr.push(temp);
        });
        setAllQuestions(qArr);        
    }

    let renderSubmitModal = () => {
        if ( !submitModal ) return null;

        return (
            <div className={'modal-wrapper'}>
                <div 
                    className={'modal-overlay'}
                    onClick={() => setSubmitModal(false)}
                ></div>
                <div className={'modal-container'}>
                    <div className={'title'}>
                        Thank you for signing up!
                    </div>
                    <div className={'subtext'}>
                        {`Your answer & result was sent to ${location?.state?.email}`}
                    </div>
                    <a 
                        className="btn-close"
                        onClick={() => setSubmitModal(false) }
                    ></a>
                </div>
            </div>
        )
    }   

    if ( !allQuestions ) return null;


    return (
        <div className={`main-wrapper`}>
            <HeaderComponent />

            <div className={'featured-question'}>
                <div className={'info-section'}>
                    <div className={'info-title'}>
                        <img
                            className={'icon-geo'}
                            src={require('../../assets/icon-geo.png')}
                        />
                        <span className={'info-text'}>
                            {featured.category}
                        </span>
                    </div>
                    <div className={'question'}>
                        {featured.question}
                    </div>  
                    <Link 
                        to={`/question/${featured.id}`}
                        className={'btn-play button'}
                    >
                        Play Now!
                    </Link>
                </div>
                <div className={'image-section'}>
                    <img src={getImage(featured)} />
                </div>
            </div>

            { /*
            <div className={'question-list'}>
                <div className={'section-title'}>
                    More Trivia Questions
                </div>
                <div className={'group-wrapper'}>
                    { allQuestions.map((e, i) => {
                        if ( i == 0 ) return null;
                        return (
                            <ItemBoxRegular q={e} key={i} />
                        )
                    })}
                </div>
            </div>
            */ }

            { renderSubmitModal() }
            
            <FooterComponent />
        </div>
    );
}

export default HomeView;
